import { useTranslation } from "react-i18next";
import {
  AccordionDetails,
  AccordionSummary,
  Box,
  Divider,
  SwitchProps,
  Typography,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useRuleContext } from "pages/Rules/Form/context/ruleContext";

import { AdvancedOptionsContainer } from "components/Styled";
import SwitchField from "components/Forms/SwitchField";
import SenderNotificationSettings from "./SenderNotification";
import DoneNotificationSettings from "./DoneNotificationSettings";
import ReminderNotificationSettings from "./ReminderNotificationSettings";
import { getSendDelay } from "pages/Rules/Form/context/ruleSelectors";

export default function AdvancedOptions() {
  const { t } = useTranslation("rules");
  const { state, dispatch } = useRuleContext();
  const { expiration } = getSendDelay(state.rule);
  const { rejectOnExpiration, allowStop } = state.rule.sendDelay;

  const onSwitchChange: SwitchProps["onChange"] = e => {
    const { name, checked } = e.target;

    dispatch({
      type: "updateSendDelay",
      payload: { [name]: checked },
    });
  };

  return (
    <AdvancedOptionsContainer>
      <AccordionSummary
        style={{ padding: "0 24px" }}
        expandIcon={<ExpandMoreIcon />}
      >
        <Typography>{t("advancedOptions")}</Typography>
      </AccordionSummary>
      <AccordionDetails
        style={{ padding: "8px 24px 40px 24px", flexDirection: "column" }}
      >
        <Box mb="15px">
          <SwitchField
            name="rejectOnExpiration"
            label={t("sendDelay.rejectOnExpiration.label")}
            description={t("sendDelay.rejectOnExpiration.desc")}
            value={rejectOnExpiration}
            onChange={onSwitchChange}
          />
        </Box>
        <Box mb="15px">
          <SwitchField
            name="allowStop"
            label={t("sendDelay.allowStop.label")}
            description={t("sendDelay.allowStop.desc")}
            value={allowStop}
            onChange={onSwitchChange}
          />
        </Box>
        <Divider style={{ marginBottom: 10, marginTop: 10 }} />
        <SenderNotificationSettings />
        <Divider style={{ marginBottom: 10, marginTop: 10 }} />
        <DoneNotificationSettings />

        {expiration.type !== "MINUTES" && (
          <>
            <Divider style={{ marginBottom: 10, marginTop: 10 }} />
            <ReminderNotificationSettings />
          </>
        )}
      </AccordionDetails>
    </AdvancedOptionsContainer>
  );
}
